import { getUserRoleName } from '@acme/domains';
import { Field, formatDateTime } from '@acme/foundation';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  $applicationHistory,
  applicationHistoryOpened,
} from '../model';

export const ApplicationHistory = () => {
  const { id } = useParams();
  const { history, opened } = useUnit({
    history: $applicationHistory,
    opened: applicationHistoryOpened,
  });

  useEffect(() => {
    if (!id) return;
    opened({ id });
  }, [id, opened]);

  return (
    <div className="flex flex-col gap-3 max-h-64 overflow-y-auto">
      {history.map((item) => (
        <div key={item.actionAt} className="flex justify-between">
          <Field
            label={formatDateTime(item.actionAt) || '-'}
            value={item.description}
          />

          <Field
            align="left"
            label={getUserRoleName(item.roleId)}
            value={item.userName}
          />
        </div>
      ))}
    </div>
  );
};

